import type React from 'react'
import type { JSX, KeyboardEvent } from 'react'
import type { FIXED_INDENTS } from 'vars/fixed-indents'
import type { DropdownItemsGroupPadding } from './DropdownItemsGroup.h'

import {
  DropdownItemsGroupAlignItems,
  DropdownItemsGroupDirection,
  DropdownItemsGroupJustifyContent,
  DropdownItemsGroupPaddings,
} from './DropdownItemsGroup.h'
import { DropdownItemsGroupStyled } from './DropdownItemsGroup.styled'

export interface IDropdownItemsGroupProps {
  children: React.ReactNode
  content?: object[] | boolean
  width?: number
  height?: number
  direction?: DropdownItemsGroupDirection
  justifyContent?: DropdownItemsGroupJustifyContent
  alignItems?: DropdownItemsGroupAlignItems
  paddings?: DropdownItemsGroupPadding
  multiColumns?: boolean
  withDivider?: boolean
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void
  dataTestId?: string
  gap?: FIXED_INDENTS
}

export const DropdownItemsGroup = ({
  children,
  content = true,
  width = 0,
  height = 0,
  direction = DropdownItemsGroupDirection.Column,
  justifyContent = DropdownItemsGroupJustifyContent.FlexStart,
  alignItems = DropdownItemsGroupAlignItems.FlexStart,
  paddings = DropdownItemsGroupPaddings.SIZE_0,
  multiColumns = false,
  withDivider = false,
  gap,
  onKeyDown,
  dataTestId = '',
}: IDropdownItemsGroupProps): JSX.Element | null =>
  // DropdownItemsGroup should not render if content falsy or empty array
  content && (typeof content === 'boolean' || content?.length > 0) ? (
    <DropdownItemsGroupStyled
      dropdownItemsGroupWidth={width}
      dropdownItemsGroupHeight={height}
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
      paddings={paddings}
      data-multicolumns={multiColumns}
      withDivider={withDivider}
      onKeyDown={onKeyDown}
      data-testid={dataTestId}
      gap={gap}
    >
      {children}
    </DropdownItemsGroupStyled>
  ) : null
